import TableCompHead from '../../../../components/ui/TableCompHead';
import TableHeaderHtmlCustom from '../../../../components/common/customTable/TableHeaderHtmlCustom';
import { HeaderStandard, constants } from '../constants';
import { useQuery } from '../../../../hooks/UseQuery';

const THead = () => {
  const part_name = useQuery('part_name');
  const part_number = useQuery('part_number');
  return (
    <thead>
      <TableCompHead
        colSpan={9}
        rowSpan={3}
        labels={['Doc.', 'Rev.No.', 'Rev. Date.']}
        values={['FM-STR-14', '01', '20/12/2023']}
        heading={constants.moduleName}
      />
      <tr>
        <th colSpan={5} align="left">
          Part Name :- {part_name || ''}
        </th>
        <th colSpan={4} align="left">
          Part Number:- {part_number || ''}
        </th>
      </tr>
      <TableHeaderHtmlCustom tableHeaderObj={HeaderStandard} />
    </thead>
  );
};

export default THead;
